import classNames from "classnames";
import {ReactNode} from "react";

import {ActionDialog, ActionDialogProps} from "@/components/overlay/ActionDialog.tsx";

import styles from "./DeleteActionDialog.module.scss";

export interface DeleteActionDialogProps {
  show: boolean;
  title: string;
  loading?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  children: ReactNode;
  size?: ActionDialogProps["size"];
  disableConfirmButton?: boolean;
  confirmBtnText?: string;
  confirmBtnVariant?: ActionDialogProps["confirmBtnVariant"];
  centered?: boolean;
  dialogClassName?: string;
}

export const DeleteActionDialog = ({children, dialogClassName, ...rest}: DeleteActionDialogProps) => {
  return (
    <ActionDialog
      {...rest}
      hasConfirmButton={true}
      hasCancelButton={true}
      backdropClassName={styles.stackedBackdrop}
      dialogClassName={classNames(styles.stackedDialog, dialogClassName)}
    >
      {children}
    </ActionDialog>
  );
};
